import axios from 'axios';
import { getToken, clearToken } from './auth';

// 后端 API 基址。PWA 离线方案中所有组件统一走此出口，便于 Service Worker 拦截与未来切换。
// 默认走跨域 IP:端口（:55 现有 build 行为不变）；HTTPS 同源 build 通过 REACT_APP_API_BASE="" 覆盖为相对路径。
export const API_BASE = process.env.REACT_APP_API_BASE !== undefined
    ? process.env.REACT_APP_API_BASE
    : "http://124.222.157.124:1060";

// 统一 axios 实例：超时 8s，避免离线时网络请求长时间挂起
export const http = axios.create({
    baseURL: API_BASE,
    timeout: 8000,
});

// 登录鉴权拦截器：自动带 token；遇 401（未登录/过期）清 token 并跳回登录页
http.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});
http.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response && err.response.status === 401) {
            clearToken();
            window.location.href = '/split';
        }
        return Promise.reject(err);
    }
);

// 生成中国时间(Asia/Shanghai, UTC+8)时间戳 "YYYY-MM-DD HH:MM:SS"。
// 注意: 必须用固定 +8h 偏移，不能用 toISOString()(那是 UTC)，否则
// 凌晨学习会被记到前一天(时区 bug)。与服务器 Asia/Shanghai 保持一致。
export function localTimestamp() {
    const sh = new Date(Date.now() + 8 * 3600 * 1000);
    const p = (n) => String(n).padStart(2, '0');
    return `${sh.getUTCFullYear()}-${p(sh.getUTCMonth() + 1)}-${p(sh.getUTCDate())} `
        + `${p(sh.getUTCHours())}:${p(sh.getUTCMinutes())}:${p(sh.getUTCSeconds())}`;
}

// 统一 API 出口：所有组件应通过 api.xxx 调用，不再各自硬编码 API_BASE 或裸用 axios
export const api = {
    getHome: () => http.get('/api/home'),
    getHomeProcess: () => http.get('/api/home/process'),
    getWords: (groupId) => http.get(`/api/words/${groupId}`),
    getAllWords: () => http.get('/api/words/all'),
    // split: 以 new_group_id 为单元上报进度(后端据此推导父组号)
    updateProgress: (new_group_id, op_type) => http.post('/api/progress/update', { new_group_id, op_type }),
    syncPush: (events) => http.post('/api/sync/push', { events }),
    syncPull: () => http.get('/api/sync/pull'),
    getCalendar: () => http.get('/api/calendar'),
    uploadPicture: (formData) => http.post('/api/picture/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    // 图片与 TTS 走 <img src>/new Audio()，不走 axios；SW 仍能拦截缓存
    // 需带 ?token= 以通过后端鉴权中间件（不登录无法取媒体）
    pictureUrl: (picId) => `${API_BASE}/api/picture/${picId}?token=${getToken()}`,
    // 走查询参数 w=，避免词内字面 "/"（如 "in the/a form of"）与 URL 路径分隔符冲突导致 404
    ttsUrl: (word) => `${API_BASE}/api/tts?w=${encodeURIComponent(word)}&token=${getToken()}`,
};
